// extracted by mini-css-extract-plugin
export var container = "_3m-0";
export var icon = "_3m-1";